import React from 'react'
import { useTranslation } from 'react-i18next'
import Button, { ButtonSize, ButtonVariant } from '@components/DesignSystem/Button'
import { useArticleContext } from '../_core'
import { Spinner } from '@components/Spinner'

type Props = {
  className?: string
}

const PublishButton = (props: Props) => {
  const { className } = props
  const { t } = useTranslation('editor')
  const {
    publishArticle,
    articleState: { publish: publishState },
    PublishButtonStatusType,
    checkInputWarnings,
  } = useArticleContext()
  const publishButtonDisabled = publishState?.status === PublishButtonStatusType.DISABLED

  const onClick = () => {
    const warnings = checkInputWarnings()
    if (warnings) return

    publishArticle()
  }

  return (
    <Button
      disabled={publishButtonDisabled}
      size={ButtonSize.block}
      variant={ButtonVariant.primary}
      onClick={onClick}
      className={className}
    >
      {publishState.status === PublishButtonStatusType.LOADING ? (
        <Spinner width={18} />
      ) : (
        t('aside.publish')
      )}
    </Button>
  )
}

export default PublishButton
